// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43847153","239":"fcd66cdf","453":"b19b9a0b","455":"4c7a9c24"}[chunkId] + ".chunk.js";
};